
import React from 'react';
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';
import { Plus, Droplets, Calendar } from 'lucide-react';
import { CycleData } from '@/utils/cycle-tracking';
import { useNavigate } from 'react-router-dom';

interface TrackingButtonsProps {
  cycleData: CycleData;
  setIsEditDialogOpen: (open: boolean) => void;
}

export const TrackingButtons: React.FC<TrackingButtonsProps> = ({ 
  cycleData, 
  setIsEditDialogOpen 
}) => {
  const navigate = useNavigate();
  
  const nextPeriodDate = format(cycleData.predictedNextPeriod, 'MMMM d');
  const nextOvulationDate = format(cycleData.predictedOvulation, 'MMMM d');
  
  const daysUntilNextPeriod = cycleData.daysUntilNextPeriod;
  const daysUntilOvulation = Math.round((cycleData.predictedOvulation.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  
  const handleLogSymptoms = () => {
    navigate('/cycle-tracking?tab=insights');
  };
  
  return (
    <div className="grid grid-cols-3 gap-4 w-full max-w-md mx-auto mt-6">
      <Button 
        onClick={handleLogSymptoms}
        variant="outline"
        className="flex flex-col items-center justify-center h-24 p-2 bg-white shadow-sm hover:bg-gray-50 border-2 border-hormony-light-coral text-hormony-coral"
      >
        <div className="rounded-full bg-hormony-light-coral p-2 mb-2">
          <Plus className="h-4 w-4 text-hormony-coral" />
        </div>
        <span className="text-xs font-medium text-center">Log your symptoms</span>
      </Button>
      
      <Button 
        variant="outline"
        className="flex flex-col items-center justify-center h-24 p-2 bg-hormony-light-coral shadow-sm hover:bg-hormony-light-coral/90 border-none text-hormony-charcoal"
      >
        <div className="rounded-full bg-white p-2 mb-2">
          <Droplets className="h-4 w-4 text-hormony-coral" />
        </div>
        <span className="text-xs font-semibold">{nextPeriodDate}</span>
        <span className="text-xs text-center">Next Period</span>
        <span className="text-xs text-center font-medium">({daysUntilNextPeriod} days)</span>
      </Button>
      
      <Button 
        variant="outline"
        className="flex flex-col items-center justify-center h-24 p-2 bg-hormony-cream shadow-sm hover:bg-hormony-cream/90 border-none text-hormony-charcoal"
      >
        <div className="rounded-full bg-white p-2 mb-2">
          <Calendar className="h-4 w-4 text-hormony-taupe" />
        </div>
        <span className="text-xs font-semibold">{nextOvulationDate}</span>
        <span className="text-xs text-center">Next Ovulation</span>
        <span className="text-xs text-center font-medium">({daysUntilOvulation} days)</span>
      </Button>
    </div>
  );
};
